import ChangePassword from './ChangePassword.vue';

export default ChangePassword;
